import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomParty} from '../../../graphql/groups.datatypes';
import {gqlRoomParty} from '../getRoomParty.api';

export interface MergeRoomInput {
    data: {
        parent_id: number
        child_id: number
    }
}

interface MergeRoomData {
    mergeRoom: RoomParty
}

export const MERGE_ROOM_MUTATION = gql`
    mutation mergeRoom($data: MergeRoomInput!) {
        mergeRoom(data: $data) {
            ${gqlRoomParty}
        }
    }
`;

export const mergeRoom = () => useMutation<MergeRoomData, MergeRoomInput>(
    MERGE_ROOM_MUTATION,
    {
        update: updateCacheByType('RoomParty'),
    }
);

export default mergeRoom;